import { getters } from '/@/modules/core/app/helpers/store';
import { CurrentEstateRouteConfig } from '/@/modules/core/app/helpers/CurrentEstateRouteConfig';
import UserService from '/@/modules/user/services/UserService';

export class BeneficiaryRouteConfig extends CurrentEstateRouteConfig {
  /**
   * @returns {boolean}
   */
  async canAccessRoute() {
    const { estateAccount } = getters.auth.getUser();

    if (estateAccount?.isBeneficiary && !estateAccount?.isResidualBeneficiary) {
      return true;
    }

    const user = await UserService.getEntity(getters.auth.getUser().id, {
      with: ['dependants.estateDistributions']
    });

    return estateAccount.isLegalGuardian && user.hasOnlySpecificBeneficiaries;
  }
}
